import { useAuth, USER_SIGNED_MESSAGE_KEY, USER_WALLET_KEY } from "@/components/auth/AuthContext";
import { HalfSunRays } from "@/components/ui/HalfSunRays";
import { IconChevronDown } from "@/components/ui/IconChevronDown";
import { PrimaryContainerComponent } from "@/components/layouts/PrimaryContainerComponent";
import { SubFooter } from "@/components/layouts/SubFooter";
import { useNavigate } from "react-router";
import { DashboardLayout } from "@/components/layouts/dashboard-layout";
import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { apiClient, isGetTokenBalanceResponse, isGetWalletResponse, web3Client } from "@/lib/api";
import { GetTokenBalanceResponse, User, WallerRetrieveData } from "@/types";
import { THINK_CONTRACT_ADDRESS } from "@/lib/swap/think";


async function getTokensForAllWallets() {
    const walletResponse = await apiClient.getWallets();
    if (isGetWalletResponse(walletResponse)) {
        const walletTokens = walletResponse.wallets.flatMap(async (wallet) => {
            const tokenBalances = await web3Client.getWalletTokens(wallet.address);
            if (isGetTokenBalanceResponse(tokenBalances)) {
                return {
                    networks: tokenBalances.allTokens,
                    wallet: {
                        address: wallet.address
                    }
                }
            }
            return {
                networks: [],
                wallet: {
                    address: wallet.address
                }
            }
        });
        return Promise.all(walletTokens);
    }
    return [];
}

export default function Dashboard() {
    const { user } = useAuth();
    const [isLoading, setIsLoading] = useState(true);
    const totalTokenBalances = {} as { [key: string]: number };

    const tokensQuery = useQuery({
        queryKey: ["dashboard-tokens"],
        queryFn: async () => {
            const tokensResponse = await getTokensForAllWallets();
            console.log("tokensReesponses", tokensResponse);
            setIsLoading(false);
            return tokensResponse;
        },
        retry: 1,
        refetchOnWindowFocus: "always",
    });

    if (tokensQuery && tokensQuery.data) {
        tokensQuery.data.map((walletTokenResponse) => {
            walletTokenResponse.networks.map((networksTokens) => {
                networksTokens.tokens.map((token) => {
                    const tokenRef = token.metadata.symbol;
                    const decimals = token.metadata.decimals;
                    console.log("token:", walletTokenResponse.wallet.address, networksTokens.network, tokenRef, (Number(token.tokenBalance)/10**decimals));
                    if (totalTokenBalances[tokenRef]) {
                        totalTokenBalances[tokenRef] += (Number(token.tokenBalance)/10**decimals);
                    } else {
                        totalTokenBalances[tokenRef] = (Number(token.tokenBalance)/10**decimals);
                    }
                });

            })
        });
    }
    // const thinkTokens = tokensQuery && tokensQuery.data && tokensQuery.data.map((tokenResponse) => {
    //     const thinkTokens = tokenResponse.tokens.filter((t) => t.contractAddress.toLowerCase() === THINK_CONTRACT_ADDRESS.toLowerCase() )
    //     return {
    //         ...tokenResponse,
    //         tokens: thinkTokens
    //     }
    // });
    let thinkTokenQuantity = undefined;
    // if (thinkTokens) {
    //     thinkTokenQuantity = thinkTokens.map((tokenResponse) => {
    //         return tokenResponse.tokens.map((t) => parseInt(t.tokenBalance, 16)).reduce((a, b) => a + b, 0);
    //     }).reduce((a, b) => a + b, 0);
    // }
    if (isLoading) {
        return (
            <DashboardLayout> 
                <div className="w-full py-16 px-4 lg:px-8 xl:px-10 2xl:px-16 3xl:px-24 min-h-[600px] bg-gradient-to-b from-teal to-black ">
                    <h1 className="text-7xl text-white font-light mb-8"> Hey {user?.ensDomain || "There"},</h1>
                    <div>Loading...</div>
                </div>
            </DashboardLayout>
        )
    }

    return (
        <DashboardLayout> 
            <div className="w-full py-16 px-4 lg:px-8 xl:px-10 2xl:px-16 3xl:px-24 min-h-[600px] bg-gradient-to-b from-teal to-black ">
                <h1 className="text-7xl text-white font-light mb-8"> Hey {user?.ensDomain || "There"},</h1>
                <div>
                    { Object.keys(totalTokenBalances).includes("THINK") ? null : (
                        <p className="text-lg text-black">You have <span className="text-white">0 THINK</span>  tokens.</p>
                    )}
                    { Object.keys(totalTokenBalances).map((tokenSymbol) => {
                        return (
                            <p key={`dashboard-token-${tokenSymbol}`} className="text-lg text-black">You have <span className="text-white">{totalTokenBalances[tokenSymbol]} {tokenSymbol}</span>  tokens.</p>
                        )
                    })}
                </div>
            </div>
        </DashboardLayout>
    );
}